enum ROUTE_ENUM {
  SUCCESS = "success",
  ERROR = "error",
  LOADING = "loading",
  HIDE = 'hide',
}

export default ROUTE_ENUM;
